import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-forbidden',
    standalone: true,
    imports: [RouterLink, MatIconModule],
    template: `
    <div class="forbidden-container">
      <div class="forbidden-card">
        <mat-icon class="forbidden-icon">lock</mat-icon>
        <h1>Accès Refusé</h1>
        <p>Vous n'avez pas les droits suffisants pour accéder à cette page.</p>
        <div class="actions">
          <a routerLink="/projects" class="btn-primary">
            <mat-icon>folder</mat-icon>
            Retour aux projets
          </a>
        </div>
      </div>
    </div>
  `,
    styles: [`
    .forbidden-container {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: calc(100vh - 200px);
      padding: 2rem;
    }
    .forbidden-card {
      background: white;
      padding: 3rem;
      border-radius: 12px;
      box-shadow: 0 10px 25px rgba(0,0,0,0.1);
      text-align: center;
      max-width: 500px;
      width: 100%;
    }
    .forbidden-icon {
      font-size: 64px;
      width: 64px;
      height: 64px;
      color: #d32f2f;
      margin-bottom: 1.5rem;
    }
    h1 {
      font-size: 2rem;
      color: #333;
      margin-bottom: 1rem;
    }
    p {
      color: #666;
      font-size: 1.1rem;
      margin-bottom: 2rem;
    }
    .actions {
      display: flex;
      justify-content: center;
    }
    .btn-primary {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      background-color: #0d47a1;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 8px;
      text-decoration: none;
      font-weight: 600;
      transition: background-color 0.2s;
    }
    .btn-primary:hover {
      background-color: #1565c0;
    }
  `]
})
export class ForbiddenComponent { }
